import {
  DialogContent,
  DialogContentText,
  Grid,
  Typography,
} from "@mui/material";
import useStyles from "../../../../components/common/model/styles";
import FormField from "../../../../components/common/FormField";
import Notification from "../../../../components/common/notification/Notification";
import Popup from "../../../../components/common/model/Popup";
import SAVE_ICON from "../../../assets/check-mark.png";
import CLOSE_ICON from "../../../../assets/closeModel.png";
import RESET_ICON from "../../../assets/trash.png";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { useSelector } from "react-redux";
import Validation from "../../../../utils/Validation";
import { setNotificationAction } from "../../../../store/reducers/mmymSlice";
import { getAllTelnetAction } from "../../../../store/reducers/adminClientsSlice";
import CustomButton from "../../../../components/common/button/CustomButton";
import { SEND_SMS_TEMPLATE_FIELDS } from "./smsAllFields";
import {
  resetNewSmsSendLocal,
  sendSmsLocalState,
  sendSmsTemplateAction,
  sendSmsTemplateResponseAction,
  setNewSmsSendLocal,
} from "../../../../store/reducers/smsTemplateSlice";
interface ManageSendEmailTemplateProps {
  open: boolean; // Define the 'open' prop
  onHide: () => void; // Define the 'onHide' prop
  title: string; // Define the 'title' prop
  selectTemplate?: any; // Adjust type as per your requirement
  setSelectedRow?: any; // Adjust type as per your requirement
  screenType?: "ADMIN" | "CLIENT"; // Add screenType prop
}

interface FilterOption {
  page: number;
  limit: number;
  orderBy: string;
  orderIn: string;
  search: string;
}

const ManageSendSmsTemplate = (props: ManageSendEmailTemplateProps) => {
  const { selectTemplate, setSelectedRow, onHide, open, title, screenType } =
    props;

  const { newSmsSendLocal, isSendSmsTemplateResponse } = useSelector(
    (state: any) => state.smsTemplate
  );

  const classes = useStyles();
  const dispatch = useDispatch();
  const [emailType, setEmailType] = useState<"single" | "bulk">("single");
  const { clients } = useSelector((state: any) => state.adminClients);
  // Store original message with placeholders
  const [templateBody, setTemplateBody] = useState<string>(
    newSmsSendLocal?.smsSend?.message || ""
  );
  const [isReset, setIsReset] = useState(false);

  const [
    error,
    checkValidator,
    resetValidator,
    resetAllValidator,
    isError,
    isErrorOptional,
  ]: any = Validation({
    to: newSmsSendLocal?.smsSend?.to,
    message: newSmsSendLocal?.smsSend?.message,
  });

  const [fullWidth, setFullWidth] = useState(true);
  const [isActionCalled, setIsActionCalled] = useState(false);

  const [filterOption, setFilterOption] = useState<FilterOption>({
    page: 1,
    limit: 1000,
    orderBy: "created_at",
    orderIn: "DESC",
    search: "client",
  });

  useEffect(() => {
    if (dispatch) {
      dispatch(getAllTelnetAction(filterOption));
    }
  }, [dispatch, filterOption]);

  useEffect(() => {
    if (selectTemplate?.body) {
      setTemplateBody(selectTemplate.body); // keep placeholder template
    }
  }, [selectTemplate]);

  useEffect(() => {
    if (selectTemplate) {
      dispatch(
        setNewSmsSendLocal({
          smsSend: {
            ...newSmsSendLocal?.smsSend,
            ...selectTemplate,
            message: selectTemplate.body,
            templateId: selectTemplate?.template_id,
          },
        })
      );
    }
  }, [selectTemplate]);

  // Replace placeholder tags in message text
  const replaceClientPlaceholders = (bodyText: string, client: any) => {
    if (!bodyText) return bodyText;

    // Define all placeholders you want to support
    const replacements: Record<string, string> = {
      "{{client_name}}": client.company || "",
      "{{email}}": client.email || "",
      "{{client_id}}": client.client_id || "",
      "{{phone}}": client.phone_number || "",
      "{{username}}": client.username || "",
    };

    // Replace all placeholders in the message
    let updatedBody = bodyText;
    Object.keys(replacements).forEach((key) => {
      const regex = new RegExp(key, "gi"); // case-insensitive replace
      updatedBody = updatedBody.replace(regex, replacements[key]);
    });

    return updatedBody;
  };

  const onChangeAction = (event: any) => {
    if (isReset) {
      return;
    }

    const { id, value, type, name } = event.target;
    const key = type === "radio" ? name : id;
    const updatedEmailTemplate = {
      ...newSmsSendLocal?.smsSend,
      [key]: value,
    };
    // ✅ Replace placeholders only when client changes
    if (key === "to" && value && emailType === "single") {
      const selectedClient = clients.find((c: any) => c.email === value);
      if (selectedClient) {
        updatedEmailTemplate.message = replaceClientPlaceholders(
          templateBody,
          selectedClient
        );
      }
    }
    // For bulk email, always use original template message
    if (emailType === "bulk") {
      updatedEmailTemplate.message = templateBody;
    }

    dispatch(setNewSmsSendLocal({ smsSend: updatedEmailTemplate }));
    resetValidator(key);
  };

  useEffect(() => {
    if (emailType === "bulk") {
      // Reset message to original template when switching to bulk
      dispatch(
        setNewSmsSendLocal({
          smsSend: {
            ...newSmsSendLocal?.smsSend,
            message: templateBody,
            to: null, // dummy value
          },
        })
      );
    } else if (emailType === "single") {
      // Optional: reset message to original template when switching back to single
      dispatch(
        setNewSmsSendLocal({
          smsSend: {
            ...newSmsSendLocal?.smsSend,
            message: templateBody,
          },
        })
      );
    }
  }, [emailType]);

  const onBlurAction = (e: any) => {
    const { id, value } = e.target;
    checkValidator(id);
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    // If bulk, force a dummy "to" value to avoid validation errors
    if (emailType === "bulk") {
      dispatch(
        setNewSmsSendLocal({
          smsSend: {
            ...newSmsSendLocal.smsSend,
            to: "bulk@example.com", // dummy value
          },
        })
      );
    }
    checkValidator();
    setIsActionCalled(true);
  };

  useEffect(() => {
    if (isActionCalled) {
      if (
        !isError() &&
        !isErrorOptional() &&
        error !== null &&
        isActionCalled
      ) {
        let payload: any = { ...newSmsSendLocal.smsSend };

        if (emailType === "bulk") {
          // For bulk email:
          payload = {
            ...payload,
            to: null, // dummy value
            send_to_all: true, // mark as bulk send
          };
        } else {
          payload.send_to_all = false; // single email
        }

        dispatch(sendSmsTemplateAction(payload));
      } else {
        console.log("error", error);
      }
      setIsActionCalled(false);
    }
    setIsActionCalled(false);
  }, [isActionCalled]);

  const hideHandler = () => {
    dispatch(sendSmsTemplateResponseAction(false));
    dispatch(setNotificationAction({ message: [], severity: "error" }));
    props.onHide();
    setSelectedRow(null);
    setTimeout(() => {
      dispatch(resetNewSmsSendLocal());
    }, 300);
  };

  useEffect(() => {
    if (isSendSmsTemplateResponse) {
      hideHandler();
    }
  }, [isSendSmsTemplateResponse]);

  const [alerModeShow, setAlertModelShow] = useState(false);
  const [isClickReset, setIsClickReset] = useState(false);

  useEffect(() => {
    if (isClickReset) {
      handleClear();
      setAlertModelShow(false);
      setIsClickReset(false);
    }
  }, [isClickReset]);

  const handleClear = () => {
    if (selectTemplate?.template_id) {
      setTimeout(() => {
        dispatch(
          setNewSmsSendLocal({
            templateId: selectTemplate?.template_id,
            smsSend: selectTemplate,
          })
        );
      }, 300);
      dispatch(
        setNewSmsSendLocal({
          smsSend: selectTemplate,
        })
      );
      resetAllValidator();
    } else {
      dispatch(setNewSmsSendLocal(sendSmsLocalState));
      setTimeout(() => {
        dispatch(resetNewSmsSendLocal());
      }, 300);
      resetAllValidator();
    }
    setIsReset(false);
  };

  const updateField = SEND_SMS_TEMPLATE_FIELDS.map((field) => {
    // ✅ For client dropdown
    if (field?.id === "to") {
      if (emailType === "bulk") {
        return {
          ...field,
          hidden: true, // custom flag to hide field
          value: "bulk@example.com", // dummy value to avoid validation
        };
      } else {
        return {
          ...field,
          options:
            clients?.map((client: any) => ({
              label: client.company, // what to display
              value: client.phone_number, // value to store
            })) || [],
        };
      }
    }
    return field;
  });

  console.log("newSmsSendLocal", newSmsSendLocal);

  return (
    <>
      <Popup
        open={open}
        title={title}
        onHide={hideHandler}
        fullWidth={fullWidth}
        maxWidth={"lg"}
        aria-describedby="alert-dialog-slide-description"
        header={
          <>
            {/* <img
              onClick={(e: any) => handleSubmit(e)}
              src={SAVE_ICON}
              className={classes.checkicons}
              alt="save"
            />
            <img
              onClick={openClearPopup}
              src={RESET_ICON}
              className={classes.deleteicons}
              alt="delete"
            /> */}
            <img
              onClick={hideHandler}
              src={CLOSE_ICON}
              className={classes.closeicons}
              alt="close"
            />
          </>
        }
        footer={
          <>
            <CustomButton
              style={{ padding: "10px 30px", height: "36px" }}
              title="Send"
              onClick={handleSubmit}
            />
          </>
        }
      >
        <DialogContent>
          <DialogContentText className={classes.formAddBox}>
            <>
              <Grid container spacing={2}>
                <Grid item xs={12} sx={{ padding: "0px" }}>
                  <Typography
                    variant="subtitle1"
                    sx={{ mb: 1, fontWeight: "600" }}
                  >
                    Select Email Type:
                  </Typography>
                  <Grid
                    container
                    spacing={2}
                    sx={{ display: "flex", justifyItems: "center" }}
                  >
                    <Grid item>
                      <input
                        type="radio"
                        id="singleEmail"
                        name="emailType"
                        value="single"
                        checked={emailType === "single"}
                        onChange={() => setEmailType("single")}
                      />
                      <label htmlFor="singleEmail" style={{ marginLeft: 4 }}>
                        Send Single Email
                      </label>
                    </Grid>
                    <Grid item>
                      <input
                        type="radio"
                        id="bulkEmail"
                        name="emailType"
                        value="bulk"
                        checked={emailType === "bulk"}
                        onChange={() => setEmailType("bulk")}
                      />
                      <label htmlFor="bulkEmail" style={{ marginLeft: 4 }}>
                        Send Bulk Email
                      </label>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Notification />
                </Grid>
                <Grid item xs={12} md={12}>
                  <Grid container spacing={2}>
                    {updateField
                      ?.filter((field: any) => !field.hidden)
                      .map((field, i) => {
                        if (
                          field.id === "signature" &&
                          newSmsSendLocal?.smsSend?.signature_option !==
                            "custom_signature"
                        ) {
                          return null; // Do not render the signature field if custom_signature is selected
                        }
                        return (
                          <>
                            <Grid
                              item
                              xs={12}
                              md={
                                field?.type === "editor" ||
                                field?.type === "radio"
                                  ? 12
                                  : 6
                              }
                              key={i}
                              sx={{ padding: "0px 4px" }}
                            >
                              <Grid container spacing={2}>
                                <FormField
                                  key={field.id}
                                  onPaste={(e) =>
                                    field?.id === "subject"
                                      ? ""
                                      : e.preventDefault()
                                  }
                                  onKeyDown={(event: any) => {
                                    setIsReset(false);
                                    console.log(
                                      "event log-",
                                      event,
                                      event.target.value + event.key
                                    );
                                    if (
                                      event.keyCode === 8 ||
                                      event.keyCode === 9 ||
                                      event.keyCode === 37 ||
                                      event.keyCode === 38 ||
                                      event.keyCode === 39 ||
                                      event.keyCode === 40 ||
                                      event.keyCode === 18 ||
                                      event.keyCode === 17 ||
                                      event.ctrlKey
                                    )
                                      return event;
                                    if (
                                      field?.patternAllowed &&
                                      !field?.patternAllowed.test(event.key)
                                    ) {
                                      event.preventDefault();
                                    } else if (
                                      field?.patternAllowed &&
                                      !field?.patternAllowed.test(
                                        event.target.value + event.key
                                      )
                                    ) {
                                      event.preventDefault();
                                    }
                                  }}
                                  {...{
                                    ...field,

                                    value: newSmsSendLocal?.smsSend
                                      ? newSmsSendLocal?.smsSend[field?.id]
                                      : "",
                                    ...{
                                      variant: "outlined", // Adding this variant prop
                                      onChange: onChangeAction,
                                      onBlur: onBlurAction,
                                      InputProps: {
                                        ...(field?.inputProps &&
                                          field?.inputProps),
                                        sx:
                                          field?.type === "text" ||
                                          field?.type === "password"
                                            ? { height: "36px" }
                                            : {
                                                padding: "10px 4px",
                                                height: "36px",
                                              },
                                      },

                                      // error:
                                      //   field?.id === "signature" &&
                                      //   newSmsSendLocal?.smsSend ===
                                      //     "custom_signature" &&
                                      //   isCustomeSignature
                                      //     ? true
                                      //     : error && error[field?.id],
                                      error: error && error[field?.id],
                                      selectedValues:
                                        newSmsSendLocal?.smsSend[field?.id],
                                      // helperText:
                                      //   emailSettingError && emailSettingError[field?.id],
                                    },
                                  }}
                                />
                              </Grid>
                            </Grid>
                          </>
                        );
                      })}
                  </Grid>
                </Grid>
              </Grid>
            </>
          </DialogContentText>
        </DialogContent>
      </Popup>
    </>
  );
};
export default ManageSendSmsTemplate;
